import { render } from "./App.vue?vue&type=template&id=47f31480"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=47f31480&lang=scss"
script.render = render

export default script